import useUploadImage from 'hooks/API/POST/useUploadImage';
import useToaster from 'hooks/useToaster';
import { memo, useCallback, useEffect, useState } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { getRandomUid } from 'utilities/uuid.service';

function AppFilePicker(props) {
  const { children, accept, referenceKey, isPublic, handleChange, text, inputProps = {} } = props;
  const headers = {
    'X-access-control': isPublic ? 'public' : 'private',
    'X-reference-key': referenceKey,
  };
  const [file, setFile] = useState(null);
  const [uploadedData, setUploadedData] = useState(null);
  const { isLoading, isError, mutateAsync } = useUploadImage({ headers });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function handleFileChange(event) {
    if (isLoading) return;

    const file = event.target.files[0];

    setFile({ rawFile: file });

    event.target.value = null; // This is enable to select the same image again
  }

  const upload = useCallback(async () => {
    const formData = new FormData();
    formData.append('file', file.rawFile);

    const response = await mutateAsync(formData);

    setUploadedData(response?.data);
  }, [file?.rawFile, mutateAsync]);

  useEffect(() => {
    if (uploadedData?.file) {
      handleChange({
        file,
        meta: uploadedData,
      });
      setFile(null);
      setUploadedData(null);
    }
  }, [file, handleChange, uploadedData, uploadedData?.file]);

  useEffect(() => {
    if (file?.rawFile) {
      if (file?.rawFile?.name) {
        const extension = `${file?.rawFile?.name}`.substring(
          `${file?.rawFile?.name}`.lastIndexOf('.')
        );

        if (!accept.includes('*.*') && !accept.includes(extension)) {
          window.alert('This extension is not allowed!');
          return;
        }
      }

      upload();
    }
  }, [accept, file, upload]);

  const { id, ...rest } = inputProps;
  const ID = id || getRandomUid();

  return (
    <>
      <label htmlFor={`#${ID}#`} className={children ? 'm-0 text-white' : 'btn-plane my-2'}>
        {children ?? (
          <>
            <span className="mx-2">
              <AiOutlineCloudUpload />
            </span>
            <span>{text}</span>
          </>
        )}
      </label>
      <input
        type="file"
        id={`#${ID}#`}
        style={{ display: 'none' }}
        accept={accept}
        onChange={handleFileChange}
        {...rest}
      />
    </>
  );
}

AppFilePicker.defaultProps = {
  isPublic: false,
  text: 'Upload file',
  referenceKey: 'ES_LOGO',
  accept: '.png,.jpg,.jpeg',
  handleChange: () => {},
};

export default memo(AppFilePicker);
